import styled from 'styled-components';
import ds from 'designsystem';

const SplashScreenPageWrapper = styled.div`
  width: 100vw;
  height: 100vh;
  position: fixed;
  top:0;
  left:0;
  z-index:9999;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${ds.brand('white')};
`;

export default SplashScreenPageWrapper;



// WEBPACK FOOTER //
// ./src/blocks/SplashScreen/SplashScreenPageWrapper.jsx